import React, { useState, useEffect } from "react";
import SideBar from "./SideBar";
import Navb from "../../components/navbar/Navb";
import Arrow from "./arrow.svg";
import { Link } from "react-router-dom";
import axios from "axios";
import "./dashboard.css";
import API_URL from "../../constants";
const ViewjobsCandidates = () => {
  const url = window.location.href;
  const id = url.substring(url.lastIndexOf("/") + 1);
  const [matchScores, setMatchScores] = useState([]);
  const [candidate, setCandidate] = useState([]);
  const [formData, setFormData] = useState({});
  const [job, setJob] = useState();
  const [status, setStatus] = useState("all");
  const fetchData = async () => {
    try {
      const url = window.location.href;
      const id = url.substring(url.lastIndexOf("/") + 1);
      const response = await axios.get(`${API_URL}/applications/job_details`, {
        params: { job_id: id },
      });
      setJob(response.data.job);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        console.log("status", status);
        const respo = await axios.get(
          `${API_URL}/admin/jobs/${id}/candidates`,
          { params: { status } } // Use status state here
        );
        console.log("respo",respo);
        console.log("respo.status",respo.status);
        if (respo.status === 200) {
          setCandidate(respo.data.candidates);
        }
      } catch (error) {
        console.error("Error:", error.request);
        console.error("Error:", error.request.status);
        if(error.request.status === 404) {
          console.error("404 found");
          setCandidate([]);
        }
      }
    };

    fetchCandidates();
  }, [id, status]);
  const fetchMatchScoresAndSetState = async (user_id, job_id, index) => {
    try {
      const resp = await axios.post(`${API_URL}/applications/match_score`, {
        user_id,
        job_id,
      });
      setMatchScores((prevMatchScores) => {
        const newScores = [...prevMatchScores]; // Copy the previous scores array
        newScores[index] = resp.data.matchScore; // Update the match score at the specified index
        console.log("matchScores", newScores[index]);
        return newScores;
      });
    } catch (error) {
      console.error("Error fetching match score:", error);
    }
  };
  useEffect(() => {
    candidate.forEach((onecandidate, index) => {
      fetchMatchScoresAndSetState(onecandidate.user_id, id, index);
    });
  }, [candidate]);

  //   const handleStatusChange = (newStatus) => {
  //     setStatus(newStatus); // Update status state when status changes
  //   };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: "long", day: "numeric", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };
  const handleStatusChange = (newStatus) => {
    // console.log("s",newStatus);
    setStatus(newStatus); // Update status state when status changes
  };
  return (
    <>
      <Navb />
      <div className="dashboard">
        <SideBar />
        <section className="rightBar">
          {candidate && candidate.length > 0 && (
            <>
              <div className="center dashboardCandidate">Candidates Detail</div>
              <div className="statusButtons filters">
                <button
                  className={
                    status === "all" ? "active selected" : "notSelected"
                  }
                  onClick={() => handleStatusChange("all")}
                >
                  All Applicants
                </button>
                <button
                  className={
                    status === "shortlisted" ? "active selected" : "notSelected"
                  }
                  onClick={() => handleStatusChange("shortlisted")}
                >
                  Shortlisted
                </button>
                <button
                  className={
                    status === "rejected" ? "active selected" : "notSelected"
                  }
                  onClick={() => handleStatusChange("rejected")}
                >
                  Rejected
                </button>
              </div>
              {/* i want 3 buttons here All Applicants ,Shortlisted,Rejected  */}

              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>YOE</th>
                    <th>Date Applied</th>
                    <th>Match Score</th>
                  </tr>
                </thead>
                <tbody>
                  {candidate.map((onecandidate, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          minWidth: "14rem",
                          borderRadius: "10px 0px 0px 10px",
                        }}
                      >
                        {onecandidate.name}
                      </td>
                      <td style={{ minWidth: "14rem" }}>
                        {onecandidate.years_of_experience}
                      </td>
                      <td>{formatDate(onecandidate.createdAt)}</td>
                      <td>
                        {matchScores && (matchScores[index] * 100).toFixed(2)}%
                      </td>
                      <td style={{ borderRadius: "0px 10px 10px 0px" }}>
                        <Link
                          to={{
                            pathname: `/dashboard/view_candidate/${onecandidate.user_id}/${job.job_id}`,
                            state: { job: job },
                          }}
                        >
                          <img src={Arrow} alt="Arrow" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {candidate && candidate.length == 0 && (
            <>
            <div className="center dashboardCandidate">Candidates Detail</div>
              <div className="statusButtons filters">
                <button
                  className={
                    status === "all" ? "active selected" : "notSelected"
                  }
                  onClick={() => handleStatusChange("all")}
                >
                  All Applicants
                </button>
                <button
                  className={
                    status === "shortlisted" ? "active selected" : "notSelected"
                  }
                  onClick={() => handleStatusChange("shortlisted")}
                >
                  Shortlisted
                </button>
                <button
                  className={
                    status === "rejected" ? "active selected" : "notSelected"
                  }
                  onClick={() => handleStatusChange("rejected")}
                >
                  Rejected
                </button>
              </div>
            <div className="noCandidate">No Candidate has Applied Yet</div></>
          )}
        </section>
      </div>
    </>
  );
};

export default ViewjobsCandidates;
